import React , {useEffect , useState  } from 'react'
import Footer from '../components/Footer'
import SideFooter from '../components/SideFooter'
import { useParams , Link, useNavigate } from 'react-router-dom';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import { getDocs , collection , db  } from '../firebase';
import Aos from 'aos';
import "aos/dist/aos.css";


const PlacesPage = () => {

  let navigate = useNavigate();

  const [ supportedPlaces , setSupportedPlaces ] = useState([]);

  useEffect(  () => {
    window.scrollTo(0 , 0);
    
    const getSupportedPlaces = async () => { 
      const querySnapshot = await getDocs(collection(db, "supported_places"));
      const placesDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setSupportedPlaces(placesDataArray);
     
    }
    getSupportedPlaces();
  } , []);

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


    let { searchFor } = useParams();
    let { searchDate } = useParams();



  return (
    <div className="main_homepage" >

    
    <NavbarHome />

 
    <div className="packages_explore explroe_hero_3" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"   >

<div className="content_top_explore">
<h1 className="heroarea_subheadline">  تصفح الاماكن السياحية </h1>
<div className="underline_line_thick"></div>
</div>



</div>

<div className="section expereinces_section ">

<div className="d-flex-c f-sp top_area_headlines container-mid">

<div className="d-flex-c  mb-2" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline" >     أكتشف ابرز ألاماكن    </h1>
</div>

<div className="sliding_back" onClick={() => navigate('/') } >
        <img src="/images/icons/left-arrow.png" alt="" />
      </div>


</div>




</div>
 
 <div className="section most_features_section container-sm">

 <div className="grid_places mb-4">

  {supportedPlaces && supportedPlaces.map(({ place_headline , place_photo,  place_desc }) => (

      <div className="single_experince_div " data-aos-duration="450"   data-aos="slide-right" data-aos-delay="10" data-aos-easing="linear" data-aos-mirror="true" >

    <img src={place_photo} alt="" className="experince_img" />

    <div className=" body_experince_card">
    <p className="location_experince_sm mt-1-small"  > {place_headline} </p>

    <p className="location_experince_sm mt-1-small color_black"> {place_desc} </p>


    <div className="d-flex-c f-sp">
    <button className="btn_category_sm ">   أعرف اكثر </button>
    <img src="/images/icons/left-arrow-purple.png" alt="" className="icon_experince" />
    </div>

    </div>

    </div>
    ))}







</div>


</div>
    
    <SideFooter />

    <Footer />
    </div>
  )
}

export default PlacesPage